/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-eval */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
import React, {
  useCallback,
  useRef,
  useState,
  useEffect,
  useMemo,
} from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import * as ts from 'typescript';
import { Container, Title, Card, BtnCenter, FlexRow } from './styles';
import { FormWrapper } from '../../styles';
import { useToast } from '../../../../hooks/toast';
import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';
import Input from '../../../../components/Input';
import EmployeeService from '../../../../services/employee';
import DepartamentosService, {
  Departamento,
} from '../../../../services/departamentos';
import { Employee } from '../../../../interfaces/employee';
import MainLoader from '../../../../components/MainLoader';

import {
  Row,
  Column,
  InfoContainer,
  IconContainer,
} from '../../../../styles/components';

interface EditParams {
  id: string;
}

const EmployeeView: React.FC = () => {
  const service = { EmployeeService: new EmployeeService() };
  const serviceDepto = { DepartamentosService: new DepartamentosService() };
  const { push } = useHistory();

  const formRefAssociar = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const [loader, setLoader] = useState<boolean>(false);
  const [modalRemover, setModalRemover] = useState<boolean>(false);
  const [employee, setEmployee] = useState<Employee>({} as Employee);
  const [modalAssociar, setModalAssociar] = useState<boolean>(false);
  const [addTarifas, setAddTarifas] = useState<any>([]);
  const [departamento, setDepartamento] = useState<Departamento>();
  const [departamentos, setDepartamentos] = useState<Departamento[]>(
    [] as Departamento[],
  );
  console.log({ departamentos });
  const [tarifas, setTarifas] = useState<any>(null);
  console.log({ tarifas });
  const [statusChecked, setStatusChecked] = useState<boolean>();
  console.log({ statusChecked });
  const [tarifasDoFuncionario, setTarifasDoFuncionario] = useState<any[]>([]);

  const { id } = useParams<EditParams>();

  const getData = useCallback(async () => {
    try {
      setLoader(true);
      const responseDepartamento =
        await serviceDepto.DepartamentosService.getDepartamentos();
      setDepartamentos(responseDepartamento.data.DepartamentoLista);

      const responseEmployee = await service.EmployeeService.getEmployeeId(id);

      setEmployee(responseEmployee.data.Funcionario);

      if (responseEmployee.data.Funcionario.Status === 'A') {
        setStatusChecked(true);
      } else {
        setStatusChecked(false);
      }
      const departamento = responseDepartamento.data.DepartamentoLista?.filter(
        (dep: Departamento) =>
          responseEmployee.data.Funcionario.CodDepartamento ===
          dep.CodigoDepartamento,
      ).map((dptoFiltrado: any) => {
        return setDepartamento(dptoFiltrado);
      });
      console.log({ departamento });
      const responseTarifas = await service.EmployeeService.getFares();
      setTarifas(responseTarifas.data.ListaInformacoesDeTarifa);

      const tarifasDoFuncionario =
        responseTarifas.data.ListaInformacoesDeTarifa.filter(
          (tarifa: any) =>
            (responseEmployee.data.Funcionario.CodigoTarifa1 ===
              tarifa.CodigoDaTarifa &&
              responseEmployee.data.Funcionario.QuantidadeTarifa1 > 0) ||
            (responseEmployee.data.Funcionario.CodigoTarifa2 ===
              tarifa.CodigoDaTarifa &&
              responseEmployee.data.Funcionario.QuantidadeTarifa2 > 0) ||
            (responseEmployee.data.Funcionario.CodigoTarifa3 ===
              tarifa.CodigoDaTarifa &&
              responseEmployee.data.Funcionario.QuantidadeTarifa3 > 0) ||
            (responseEmployee.data.Funcionario.CodigoTarifa4 ===
              tarifa.CodigoDaTarifa &&
              responseEmployee.data.Funcionario.QuantidadeTarifa4 > 0),
        );
      await setTarifasDoFuncionario(tarifasDoFuncionario);
      setLoader(false);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    const runAsync = async () => {
      getData();
    };
    runAsync();
  }, [id]);

  const changedTarifas = useMemo(() => {
    const tarifas = tarifasDoFuncionario.map((item: any, index: any) => {
      const itemText = `QuantidadeTarifa${index + 1}`;
      const result = ts.transpile('employee[itemText]');
      const runnable: any = eval(result);
      const retorno: any = {
        tarifaName: item.CodigoDaTarifa,
        quantidade: runnable,
      };
      return retorno;
    });

    setAddTarifas(tarifas);
    return tarifasDoFuncionario;
  }, [tarifasDoFuncionario]);

  const removerFuncionario = useCallback(
    async (data: any) => {
      try {
        console.log({ data });
        await service.EmployeeService.deleteEmployee(id);
        push('/funcionarios');
      } catch (err: any) {
        console.error(err);
        setModalRemover(false);
        const mensagem = `${err.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}. ${err.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`;
        addToast({
          type: 'error',
          title: 'Erro ao excluir',
          description: mensagem,
        });
      }
    },
    [addToast],
  );

  const handleSubmitAssociar = useCallback(
    async (data: any) => {
      try {
        setLoader(true);
        await service.EmployeeService.linkCardManual(
          employee.CodigoDoFuncionario.toString(),
          data.cardnumber,
        );
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Cartão associado com sucesso.',
        });
        await setEmployee({ ...employee, CrtCodIdentifExt: data.cardnumber });
        setLoader(false);
      } catch (err: any) {
        const mensagem =
          err.response.data.Summary.ErrorCollection.DataValidationErros[0]
            .InternalErrorMessage;
        console.error(err);

        addToast({
          type: 'error',
          title: 'Erro ao associar',
          description: mensagem,
        });
        setLoader(false);
      }
    },
    [employee, addToast],
  );

  return (
    <Container>
      {loader ? (
        <MainLoader />
      ) : (
        <>
          <Row className="titleWrapper">
            <Column small="2" medium="2" large="2">
              <IconContainer align="center">
                <HiOutlineUserGroup size={112} />
              </IconContainer>
            </Column>
            <Column
              small="10"
              medium="10"
              large="10"
              className="TitleContainer"
            >
              <Title>
                {employee?.Nome}
                <Link to="/funcionarios">
                  <AiOutlineArrowLeft size={30} style={{ color: '#3F1159' }} />
                </Link>
              </Title>
              <div className="labelContainer">
                {/* {employee?.Status === 'A' ? (
                  <div className="activeLabel green">Ativo</div>
                ) : (
                  <div className="activeLabel gray">Inativo</div>
                )} */}
                {employee?.CrtCodIdentifExt ? (
                  <Link
                    to={`/cartoes/${employee.CrtCodIdentifExt}`}
                    className="activeLabel green"
                  >
                    {`Cartão Associado - ${employee?.CrtCodIdentifExt}`}
                  </Link>
                ) : (
                  <div className="activeLabel gray">
                    Nenhum Cartão Associado
                  </div>
                )}
              </div>
            </Column>
          </Row>

          <Row className="CardContainer1">
            <Column small="2" medium="2" large="2" />
            <Column small="10" medium="10" large="10">
              <div className="buttonsContainer">
                {employee.CrtCodIdentifExt === null && (
                  <Button
                    color="orange"
                    padding="1"
                    type="button"
                    className="white"
                    onClick={() => setModalAssociar(true)}
                  >
                    Associar Cartão
                  </Button>
                )}
                <Button
                  color="green"
                  padding="1"
                  type="button"
                  className="white"
                  onClick={() =>
                    push(`/funcionarios/${employee.CodigoDoFuncionario}/editar`)
                  }
                >
                  Editar Funcionário
                </Button>
                <Button
                  color="red"
                  padding="1"
                  type="button"
                  className="purple"
                  onClick={() => setModalRemover(true)}
                >
                  Remover Funcionário
                </Button>
              </div>
              <Card>
                <div className="CardTitle">Dados</div>
                <div className="CardForm">
                  <Row>
                    <Column small="12" medium="12" large="12">
                      <div className="title">Nome</div>
                      {employee?.Nome ? (
                        <>
                          {employee?.Nome.trim() ? (
                            <div className="text">{employee?.Nome}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>

                    <Column small="6" medium="6" large="6">
                      <div className="title">CPF</div>
                      {employee?.FuncCpf ? (
                        <>
                          {employee?.FuncCpf.trim() ? (
                            <div className="text">{employee?.FuncCpf}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>

                    <Column small="6" medium="6" large="6">
                      <div className="title">MATRÍCULA</div>
                      {employee?.Matricula ? (
                        <>
                          {employee?.Matricula.trim() ? (
                            <div className="text">{employee?.Matricula}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>

                    {/* <Column small="6" medium="6" large="6">
                      <div className="title">SALÁRIO</div>
                      {employee?.Salario > 0 ? (
                        <div className="text">{employee?.Salario}</div>
                      ) : (
                        <div className="text">--</div>
                      )}
                    </Column>

                    <Column small="6" medium="6" large="6">
                      <div className="title">CARGO</div>
                      {employee?.Cargo ? (
                        <>
                          {employee?.Cargo.trim() ? (
                            <div className="text">{employee?.Cargo}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>

                    <Column small="6" medium="6" large="6">
                      <div className="title">TELEFONE</div>
                      {employee?.Telefone ? (
                        <>
                          {employee?.Telefone.trim() ? (
                            <div className="text">{employee?.Telefone}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column> */}

                    <Column small="6" medium="6" large="6">
                      <div className="title">DEPARTAMENTO</div>
                      {departamento?.Nome ? (
                        <>
                          {departamento?.Nome.trim() ? (
                            <div className="text">{departamento?.Nome}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>
                  </Row>
                </div>
              </Card>
            </Column>
          </Row>
          {/* <Row className="CardContainer">
            <Column small="2" medium="2" large="2">
              <InfoContainer />
            </Column>
            <Column small="10" medium="10" large="10">
              <Card>
                <div className="CardTitle">Endereço</div>
                <div className="CardForm">
                  <Row>
                    <Column small="6" medium="6" large="6">
                      <div className="title">RUA E NÚMERO</div>

                      {employee?.Endereco ? (
                        <>
                          {employee?.Endereco.trim() ? (
                            <div className="text">{employee?.Endereco}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>

                    <Column small="6" medium="6" large="6">
                      <div className="title">CEP</div>
                      {employee?.CEP ? (
                        <>
                          {employee?.CEP.trim() ? (
                            <div className="text">{employee?.CEP}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>

                    <Column small="6" medium="6" large="6">
                      <div className="title">BAIRRO</div>
                      {employee?.Bairro ? (
                        <>
                          {employee?.Bairro.trim() ? (
                            <div className="text">{employee?.Bairro}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>

                    <Column small="6" medium="6" large="6">
                      <div className="title">CIDADE</div>
                      {employee?.Municipio ? (
                        <>
                          {employee?.Municipio.trim() ? (
                            <div className="text">{employee?.Municipio}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>
                  </Row>
                </div>
              </Card>
            </Column>
          </Row> */}
          <Row className="CardContainer">
            <Column small="2" medium="2" large="2">
              <InfoContainer />
            </Column>
            <Column small="10" medium="10" large="10">
              <Card>
                <div className="CardTitle">Tarifas por dia</div>
                <div className="CardForm">
                  {addTarifas.map((tarifa: any, index: any) => (
                    <Row key={`key${index + 1}`}>
                      <Column
                        small="7"
                        medium="7"
                        large="7"
                        className="tarifaOptions"
                      >
                        <div className="title">{`Tarifa ${index + 1}`}</div>
                        <div className="text">
                          {
                            tarifasDoFuncionario?.filter(
                              (tarif: any) =>
                                tarif.CodigoDaTarifa === tarifa.tarifaName,
                            )[0]?.Descricao
                          }
                        </div>
                      </Column>
                      <Column
                        small="5"
                        medium="5"
                        large="5"
                        className="tarifaOptions"
                      >
                        <div className="title">
                          {`Quantidade Tarifa ${index + 1}`}
                        </div>
                        <div className="text">{tarifa.quantidade}</div>
                      </Column>
                    </Row>
                  ))}
                </div>
              </Card>
            </Column>
          </Row>
          {employee?.CrtCodIdentifExt && (
            <Row className="CardContainer">
              <Column small="2" medium="2" large="2">
                <InfoContainer />
              </Column>
              <Column small="10" medium="10" large="10">
                <Card>
                  <div className="CardTitle">Cartão</div>
                  <div className="CardForm CardLink">
                    <div className="title">Numero do Cartão</div>
                    <Link
                      to={`/cartoes/${employee.CrtCodIdentifExt}`}
                      className="cardLink"
                    >
                      {`  ${employee?.CrtCodIdentifExt}`}
                    </Link>
                  </div>
                </Card>
              </Column>
            </Row>
          )}
        </>
      )}

      {modalRemover && (
        <Modal
          handleClose={() => setModalRemover(false)}
          show={modalRemover}
          title="Remoção de funcionário"
        >
          Tem certeza de que deseja remover {employee?.Nome}?
          <BtnCenter>
            <Button
              type="button"
              padding=""
              color="orange"
              className="btn"
              onClick={() => setModalRemover(false)}
            >
              Não
            </Button>
            <Button
              type="button"
              padding=""
              color="orange"
              className="btn-remover"
              onClick={removerFuncionario}
            >
              Sim, remover
            </Button>
          </BtnCenter>
        </Modal>
      )}

      <Modal
        handleClose={() => setModalAssociar(false)}
        show={modalAssociar}
        title="Associação manual"
      >
        Digite o número do cartão que deseja associar.
        <FormWrapper>
          <Form ref={formRefAssociar} onSubmit={handleSubmitAssociar}>
            <Input
              id="cardnumber"
              name="cardnumber"
              type="text"
              cardtransfacil
              label="Número do cartão"
            />

            <FlexRow>
              <div className="btn-wrapper">
                <Button
                  type="button"
                  padding=""
                  color="orange"
                  className="btn"
                  role="button"
                  onClick={() => setModalAssociar(false)}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  padding=""
                  color="orange"
                  className="btnconf"
                >
                  Confirmar
                </Button>
              </div>
            </FlexRow>
          </Form>
        </FormWrapper>
      </Modal>
    </Container>
  );
};

export default EmployeeView;
